import { useEffect, useRef } from 'react';
import api from '../services/api';

const HEARTBEAT_INTERVAL = 30000; // 30 seconds

/**
 * Sends periodic heartbeat pings to keep the user's online status active.
 * Should be mounted once in the app (e.g., in AuthProvider or DashboardLayout).
 */
export default function useHeartbeat() {
  const intervalRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) return;

    const sendHeartbeat = () => {
      api.post('/accounts/heartbeat/').catch(() => {});
    };

    // Send immediately on mount
    sendHeartbeat();

    intervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
}
